/**
 * Cart drawer offers - gift picker + one-of-three offer selection.
 *
 * This file is loaded from layout/theme.liquid on every page (whenever the cart type is
 * 'drawer'), NOT inline in the snippet. snippets/lz-offers.liquid only renders for a
 * non-empty cart, and drawer refreshes replace #CartDrawer.innerHTML, which never executes
 * <script> tags - so anything inline there would be dead for a visitor who arrived with an
 * empty cart and then added their first item. Keep this here.
 *
 * All handlers are document-level delegates so they survive every drawer re-render.
 */
(function () {
  if (window.__lzOffersInit) return;
  window.__lzOffersInit = true;

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var panelOpen = false;
  var busy = false;

  function post(url, payload) {
    return fetch(url, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(payload) }).then(function (r) {
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* Redraw the drawer from the server so Liquid re-evaluates every offer state. */
  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();

        if (sections['cart-drawer']) {
          var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = newDoc.getElementById('CartDrawer');
          var live = document.getElementById('CartDrawer');
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        }

        if (sections['cart-icon-bubble']) {
          var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.querySelector('.shopify-section');
          var oldBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
        }

        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
          drawerEl.classList.remove('is-empty');
          drawerEl.classList.add('animate', 'active');
        }
        applyPanelState();
      });
  }

  function applyPanelState() {
    var panel = document.getElementById('LzOffersPanel');
    var toggle = document.getElementById('LzOffersToggle');
    if (!panel || !toggle) return;
    panel.hidden = !panelOpen;
    toggle.setAttribute('aria-expanded', panelOpen ? 'true' : 'false');
    if (panelOpen) {
      toggle.classList.add('lz-offers__toggle--open');
    } else {
      toggle.classList.remove('lz-offers__toggle--open');
    }
  }

  function setBusy(on) {
    busy = on;
    var panel = document.getElementById('LzOffersPanel');
    if (!panel) return;
    if (on) {
      panel.classList.add('lz-offers__busy');
    } else {
      panel.classList.remove('lz-offers__busy');
    }
  }

  /* A gift line is only free while FREEGIFT applies. Leaving it in the cart after
     switching to another offer would silently charge the customer for it. */
  function removeGiftLine() {
    return getCart().then(function (cart) {
      var gift = cart.items.filter(function (i) {
        return i.properties && i.properties._free_gift;
      })[0];
      if (!gift) return null;
      return post('/cart/change.js', { id: gift.key, quantity: 0 });
    });
  }

  /* /cart/update.js REPLACES the whole discount code set (and '' clears it).
     /discount/CODE does NOT - codes accumulate there and can never be removed,
     which makes switching offers impossible. Do not swap this back. */
  function selectOffer(code) {
    if (busy) return;
    setBusy(true);
    var chain = code === 'FREEGIFT' ? Promise.resolve() : removeGiftLine();
    chain
      .then(function () {
        return post('/cart/update.js', { discount: code, attributes: { lz_offer: code } });
      })
      .then(refreshDrawer)
      .catch(function (e) { console.error('LZ offers: could not select offer', e); })
      .then(function () { setBusy(false); });
  }

  function clearOffer() {
    if (busy) return;
    setBusy(true);
    removeGiftLine()
      .then(function () {
        return post('/cart/update.js', { discount: '', attributes: { lz_offer: '' } });
      })
      .then(refreshDrawer)
      .catch(function (e) { console.error('LZ offers: could not clear offer', e); })
      .then(function () { setBusy(false); });
  }

  function removeGiftByKey(key) {
    if (busy) return;
    setBusy(true);
    post('/cart/change.js', { id: key, quantity: 0 })
      .then(refreshDrawer)
      .catch(function (e) { console.error('LZ offers: could not remove gift', e); })
      .then(function () { setBusy(false); });
  }

  function addGift(button) {
    if (busy) return;
    setBusy(true);
    button.disabled = true;
    post('/cart/add.js', {
      items: [{ id: button.getAttribute('data-free-gift-variant-id'), quantity: 1, properties: { _free_gift: 'true' } }]
    })
      .then(function (data) {
        if (data && data.status) throw new Error(data.description || 'Could not add gift');
        return refreshDrawer();
      })
      .catch(function (error) {
        console.error('Free gift: could not add product to cart', error);
        button.disabled = false;
        window.alert('Sorry, that gift could not be added. Please try another one.');
      })
      .then(function () { setBusy(false); });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var toggle = target.closest('#LzOffersToggle');
    if (toggle) {
      event.preventDefault();
      panelOpen = !panelOpen;
      applyPanelState();
      return;
    }

    var choice = target.closest('[data-lz-offer]');
    if (choice) {
      event.preventDefault();
      if (choice.disabled) return;
      var code = choice.getAttribute('data-lz-offer');
      /* Tapping the selected offer again clears it. */
      if (choice.getAttribute('aria-pressed') === 'true') {
        clearOffer();
      } else {
        selectOffer(code);
      }
      return;
    }

    if (target.closest('#LzOffersClear')) {
      event.preventDefault();
      clearOffer();
      return;
    }

    var removeBtn = target.closest('[data-lz-remove-gift]');
    if (removeBtn) {
      event.preventDefault();
      removeGiftByKey(removeBtn.getAttribute('data-lz-remove-gift'));
      return;
    }

    var giftBtn = target.closest('.free-gift-picker__item');
    if (giftBtn && !giftBtn.disabled && giftBtn.getAttribute('data-free-gift-variant-id')) {
      event.preventDefault();
      addGift(giftBtn);
    }
  });

  /* Dawn's cart-drawer.js also re-renders the drawer on quantity changes, which would
     otherwise reset the open/closed state. Watch childList only; state is applied via
     attributes, so this cannot feed itself. */
  function watch() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.__lzWatched) return;
    drawer.__lzWatched = true;
    new MutationObserver(applyPanelState).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(); applyPanelState(); });
  } else {
    watch();
    applyPanelState();
  }
})();